module.exports = __webpack_public_path__ + "static/media/persona-ryan.557fe04e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/Onboarding/persona-ryan.jpg
// module id = 185
// module chunks = 0